import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { resetSignAllStudentAttendanceSheetsState, signAllStudentAttendanceSheets } from "./sign-all-student-attendance-sheets";

const initialState: ProcessingState = { processing: "idle" };

export const signAllStudentAttendanceSheetsReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(signAllStudentAttendanceSheets.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(signAllStudentAttendanceSheets.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(signAllStudentAttendanceSheets.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetSignAllStudentAttendanceSheetsState, () => {
    return initialState;
  });
});
